export const MEDIA_RELATION_KEYS: ReadonlySet<string> = new Set([
  "answer_1_image",
  "answer_2_image",
  "answer_3_image",
  "audio_catch",
  "audio_fail",
  "audio_success",
  "default_image_1",
  "default_image_2",
  "image_fail",
  "image_success",
  "source_audio",
  "source_avatar",
  "source_avatar_debrief",
  "source_image",
  "source_image_2d",
  "source_logo",
  "source_media",
  "source_media_loose_sound",
  "source_media_win_sound",
  "source_model3d",
  "source_pdf",
  "source_video_tuto",
  "source_voice",
]);

export const OPTIONAL_MEDIA_FIELDS_BY_MODEL: Record<string, ReadonlySet<string>> = {
  "content-quizz-3": new Set(["source_media_win_sound", "source_media_loose_sound"]),
  "content-quizz-image-multiple": new Set(["source_media_win_sound", "source_media_loose_sound"]),
  "content-quizz-sort": new Set(["source_media_win_sound", "source_media_loose_sound"]),
  "content-random-quizz": new Set(["source_media_win_sound", "source_media_loose_sound"]),
  "content-yes-no-question": new Set(["source_media_win_sound", "source_media_loose_sound"]),
  "content-quizz-2": new Set(["answer_1_image", "answer_2_image", "answer_3_image"]),
  "content-avatar-ai": new Set(["source_medias"]),
  "content-avatar-ai-persona": new Set(["source_avatar_debrief", "pdf_items"]),
  "content-scene": new Set(["source_model3d"]),
  "content-text": new Set(["source_voice"]),
  "content-zone-sort": new Set(["source_video_tuto"]),
  "content-element-catch": new Set(["source_video_tuto"]),
  "content-fire-extinguisher": new Set(["source_video_tuto"]),
  "content-clean": new Set(["source_video_tuto", "default_image_1", "default_image_2"]),
};

export const isOptionalMediaField = (modelName: string, fieldName: string): boolean =>
  OPTIONAL_MEDIA_FIELDS_BY_MODEL[modelName]?.has(fieldName) ?? false;

export const DEFAULT_AVATAR_MEDIA_ID = 9848;

export const isEmptyMediaSentinel = (value: unknown): boolean => value === -1 || value === "-1";

export const findEmptyMediaRelationKeys = (
  changes: Record<string, unknown>,
  modelName?: string,
): string[] =>
  Object.keys(changes).filter(
    (k) =>
      MEDIA_RELATION_KEYS.has(k) &&
      isEmptyMediaSentinel(changes[k]) &&
      !(modelName && isOptionalMediaField(modelName, k)),
  );

export const stripEmptyMediaRelations = <T extends Record<string, unknown>>(changes: T): T => {
  const result = { ...changes } as Record<string, unknown>;
  for (const k of Object.keys(changes)) {
    if (MEDIA_RELATION_KEYS.has(k) && isEmptyMediaSentinel(changes[k])) {
      delete result[k];
    }
  }
  return result as T;
};
